import { WSService } from "../../../../utils/WSService";

export const monitorSettingsService = new WSService(
  "/v2/insurance/monitor-settings"
);
